import {
  GetSearchEnabledTagsQuery_query_searchTags_Tag_articleUsages_BrandedArticleUsage,
  TagType,
} from '../__generated__/queries-web';

export const getTagTotalArticleUsage = (
  articleUsages: GetSearchEnabledTagsQuery_query_searchTags_Tag_articleUsages_BrandedArticleUsage[],
) => articleUsages.reduce((prev, articleUsage) => prev + articleUsage.total, 0);

const TAG_TYPES_WITH_UNTRACKED_USAGE = [
  TagType.TvCollection,
  TagType.TvProgram,
  TagType.Video,
];

// Usages of these tag types are never reported in articleUsages, so filtering
// on "at least one usage" would hide all of them
export const hasUntrackedArticleUsage = (type: TagType): boolean =>
  TAG_TYPES_WITH_UNTRACKED_USAGE.includes(type);
